/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MdmUnresolvedObservationDto } from './MdmUnresolvedObservationDto';
import {
    MdmUnresolvedObservationDtoFromJSON,
    MdmUnresolvedObservationDtoFromJSONTyped,
    MdmUnresolvedObservationDtoToJSON,
    MdmUnresolvedObservationDtoToJSONTyped,
} from './MdmUnresolvedObservationDto';
import type { TimezoneMetadata } from './TimezoneMetadata';
import {
    TimezoneMetadataFromJSON,
    TimezoneMetadataFromJSONTyped,
    TimezoneMetadataToJSON,
    TimezoneMetadataToJSONTyped,
} from './TimezoneMetadata';

/**
 * Paginated unresolved asset observation queue
 * @export
 * @interface MdmUnresolvedObservationsListResponse
 */
export interface MdmUnresolvedObservationsListResponse {
    /**
     * 
     * @type {boolean}
     * @memberof MdmUnresolvedObservationsListResponse
     */
    success?: boolean;
    /**
     * 
     * @type {Array<MdmUnresolvedObservationDto>}
     * @memberof MdmUnresolvedObservationsListResponse
     */
    data?: Array<MdmUnresolvedObservationDto>;
    /**
     * 
     * @type {number}
     * @memberof MdmUnresolvedObservationsListResponse
     */
    total?: number;
    /**
     * 
     * @type {number}
     * @memberof MdmUnresolvedObservationsListResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof MdmUnresolvedObservationsListResponse
     */
    pageSize?: number;
    /**
     * 
     * @type {string}
     * @memberof MdmUnresolvedObservationsListResponse
     */
    errorMessage?: string;
    /**
     * 
     * @type {string}
     * @memberof MdmUnresolvedObservationsListResponse
     */
    userTimezone?: string;
    /**
     * Error message if the request failed
     * @type {string}
     * @memberof MdmUnresolvedObservationsListResponse
     */
    error?: string;
    /**
     * 
     * @type {TimezoneMetadata}
     * @memberof MdmUnresolvedObservationsListResponse
     */
    timezoneMetadata?: TimezoneMetadata;
}

/**
 * Check if a given object implements the MdmUnresolvedObservationsListResponse interface.
 */
export function instanceOfMdmUnresolvedObservationsListResponse(value: object): value is MdmUnresolvedObservationsListResponse {
    return true;
}

export function MdmUnresolvedObservationsListResponseFromJSON(json: any): MdmUnresolvedObservationsListResponse {
    return MdmUnresolvedObservationsListResponseFromJSONTyped(json, false);
}

export function MdmUnresolvedObservationsListResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): MdmUnresolvedObservationsListResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'success': json['success'] == null ? undefined : json['success'],
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(MdmUnresolvedObservationDtoFromJSON)),
        'total': json['total'] == null ? undefined : json['total'],
        'page': json['page'] == null ? undefined : json['page'],
        'pageSize': json['pageSize'] == null ? undefined : json['pageSize'],
        'errorMessage': json['errorMessage'] == null ? undefined : json['errorMessage'],
        'userTimezone': json['userTimezone'] == null ? undefined : json['userTimezone'],
        'error': json['error'] == null ? undefined : json['error'],
        'timezoneMetadata': json['timezone_metadata'] == null ? undefined : TimezoneMetadataFromJSON(json['timezone_metadata']),
    };
}

export function MdmUnresolvedObservationsListResponseToJSON(json: any): MdmUnresolvedObservationsListResponse {
    return MdmUnresolvedObservationsListResponseToJSONTyped(json, false);
}

export function MdmUnresolvedObservationsListResponseToJSONTyped(value?: MdmUnresolvedObservationsListResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'success': value['success'],
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(MdmUnresolvedObservationDtoToJSON)),
        'total': value['total'],
        'page': value['page'],
        'pageSize': value['pageSize'],
        'errorMessage': value['errorMessage'],
        'userTimezone': value['userTimezone'],
        'error': value['error'],
        'timezone_metadata': TimezoneMetadataToJSON(value['timezoneMetadata']),
    };
}

